module.exports = __webpack_public_path__ + "static/Harmons-7fb4099d9b84df932e198b26b7db1a72.png";